
import { defineComponent } from 'vue'
import Column from 'primevue/column'
import DataTable from 'primevue/datatable'
import { filterDefault } from '@/helpers/commons/filterHelper'
import { FilterOperator } from 'primevue/api'
import addActionDialogDescriptor from './AlertDefinitionActionDialogDescriptor.json'

export default defineComponent({
    name: 'etl-card',
    components: {
        DataTable,
        Column
    },
    props: {
        loading: {
            type: Boolean
        },
        files: {
            type: Array as any
        },
        data: {
            type: Object
        }
    },
    created() {
        this.loadData()
    },
    data() {
        return {
            addActionDialogDescriptor,
            selectedFiles: [] as any,
            myData: {} as any,
            filters: {
                global: [filterDefault],
                label: {
                    operator: FilterOperator.AND,
                    constraints: [filterDefault]
                },
                name: {
                    operator: FilterOperator.AND,
                    constraints: [filterDefault]
                }
            } as Object
        }
    },
    methods: {
        loadData() {
            this.myData = this.data as any
            this.selectedFiles = this.myData?.jsonActionParameters?.listDocIdSelected ? [...this.myData.jsonActionParameters.listDocIdSelected] : []
        },
        fileSelected() {
            this.myData.jsonActionParameters.listDocIdSelected = this.selectedFiles.map((doc: any) => {
                return { DOCUMENT_ID: doc.DOCUMENT_ID }
            })
        }
    }
})
